module.exports = __webpack_public_path__ + "static/media/logo.f8cc34f0.png";